import api from './index'
import type { ApiResponse, V1ApiResponse } from '@/types'

export const MESSAGE_CATEGORY_OFFICIAL = 'OFFICIAL'
export const MESSAGE_READ_UNREAD = 0
export const MESSAGE_READ_READ = 1

export interface MessageCategoryItem {
  messageCategoryCode: string
  messageName: string
  iconUrl?: string | null
  sort: number
  unreadCount: number
}

export interface MessageUserSnapshot {
  userId: number
  nickname: string
  avatar?: string | null
}

export interface UserMessageItem {
  messageId: number
  messageCategoryCode: string
  messageTypeCode: string
  messageTemplateCode?: string | null
  messageTemplateVersion?: number | null
  receiverUserId: number
  senderUser?: MessageUserSnapshot | null
  subjectType?: string | null
  subjectId?: number | null
  subjectOwnerUserId?: number | null
  objectType?: string | null
  objectId?: number | null
  objectContent?: string | null
  title: string
  content: string
  targetType?: string | null
  targetId?: number | null
  jumpUrl?: string | null
  jumpParam?: Record<string, unknown> | null
  payload?: Record<string, unknown> | null
  readStatus: number
  readDateTime?: string | null
  followState?: string
  createDateTime: string
}

export interface UserMessagePage {
  list: UserMessageItem[]
  total: number
  page: number
  pageSize: number
}

export interface MessageListQuery {
  categoryCode?: string
  readStatus?: number
  page?: number
  pageSize?: number
}

export interface MarkAllMessagesReadData {
  updatedCount: number
  readAt: string
}

export interface ClearMessagesData {
  clearedCount: number
  clearedAt: string
}

// 消息API接口
export const messageApi = {
  // 官方消息列表
  getMessageList: (params: any): Promise<ApiResponse<any>> =>
    api.get('/api-message/msgMessage/msgByUserId', { params }),

  // 标记消息为已读（如果后端有这个接口的话）
  markAsRead: (params: any): Promise<ApiResponse<any>> =>
    api.post('/api-message/msgMessage/markRead', params),

  // 获取未读消息数量（如果后端有这个接口的话）
  getUnreadCount: (params: any): Promise<ApiResponse<any>> =>
    api.get('/api-message/msgMessage/unreadCount', { params }),

  /** 查询消息分类，无需传递查询参数 */
  queryCategories: (): Promise<V1ApiResponse<MessageCategoryItem[]>> =>
    api.get('/v1/messages/categories'),

  /** 当前用户消息分页列表 */
  queryMessages: (params?: MessageListQuery): Promise<V1ApiResponse<UserMessagePage>> =>
    api.get('/v1/messages', { params }),

  /** 当前用户单条消息详情 */
  queryMessage: (messageId: number): Promise<V1ApiResponse<UserMessageItem>> =>
    api.get(`/v1/messages/${messageId}`),

  /** 单条消息已读 */
  markMessageRead: (
    messageId: number
  ): Promise<V1ApiResponse<{ messageId: number; readStatus: number; readAt: string }>> =>
    api.post(`/v1/messages/${messageId}/read`),

  /** 批量消息已读，可按分类过滤 */
  markAllRead: (categoryCode?: string): Promise<V1ApiResponse<MarkAllMessagesReadData>> =>
    api.post('/v1/messages/read-all', categoryCode ? { categoryCode } : {}),

  /** 一键软删除当前用户消息，可按已读状态过滤 */
  clearMessages: (readStatus?: number): Promise<V1ApiResponse<ClearMessagesData>> =>
    api.post('/v1/messages/clear', readStatus == null ? {} : { readStatus }),
}

export default messageApi
